export default __webpack_public_path__ + "static/media/Superdickayan.92187fd8.PNG";